import React from "react";
import cx from "classnames";
import { upperFirst } from "lodash-es";

import styles from "./iteration-item.module.scss";
import { polymorphic } from "../utils";
import IconContainer from "../IconContainer/IconContainer";
import ChevronRight from "../../assets/icons/chevron-right.svg";

export namespace IterationItem {
  export type Props = {
    as?: "div" | "td" | "li";
    className?: string;
    size?: "small" | "medium";
    hasChildren?: boolean;
  };
}

export const IterationItem = polymorphic("div")<IterationItem.Props>(
  ({
    as: Component,
    children,
    className,
    hasChildren,
    size = "medium",
    ...props
  }) => {
    const classList = cx(
      className,
      styles.iteration,
      styles[`iteration${upperFirst(size)}` as keyof typeof styles]
    );

    return (
      <Component {...props} className={classList}>
        <div className={styles.iterationContainer}>
          <div className={styles.iterationContainerContent}>{children}</div>
          {hasChildren && (
            <IconContainer
              className={styles.iterationContainerChildrenIndicator}
              icon={ChevronRight}
              size={6}
            />
          )}
        </div>
      </Component>
    );
  }
);
